import { History, Workflow } from 'lucide-react'

import { defineArea, defineModule } from '@/lib/module-routes'
import { WORKFLOW_PERMISSIONS } from '@/lib/permissions'

import { flowRoute } from './flow-route'
import { workflowEditorRoute, workflowRunRoute, workflowRunsRoute, workflowsRoute } from './routes'

const flowArea = defineArea({
  id: 'flow',
  label: 'Flow sections',
  product: 'flow',
  gated: true,
  route: flowRoute,
})

declare module '@/lib/module-routes' {
  interface Areas {
    flow: typeof flowArea
  }
}

export const workflowsModule = defineModule({
  routes: [flowRoute, workflowsRoute, workflowEditorRoute, workflowRunsRoute, workflowRunRoute],
  products: [
    {
      id: 'flow',
      label: 'Flow',
      description: 'Build and run workflows',
      icon: Workflow,
      order: 80,
      routes: [flowRoute],
    },
  ],
  areas: [flowArea],
  sections: {
    flow: [{ id: 'workflows', label: 'Workflows', order: 10 }],
  },
  navigation: {
    flow: [
      {
        to: '/$entityId/workflows',
        label: 'Workflows',
        icon: Workflow,
        permission: WORKFLOW_PERMISSIONS.read,
        section: 'workflows',
        order: 10,
      },
      {
        to: '/$entityId/workflow-runs',
        label: 'Workflow runs',
        icon: History,
        permission: WORKFLOW_PERMISSIONS.read,
        section: 'workflows',
        order: 20,
      },
    ],
  },
})
